import { ImageScanOverlay } from '../ImageScanOverlay';
import type { ImageSearchResultType } from '../../types/type';
import CenterScreenWrapper from '../CenterScreenWrapper';
import { t } from 'i18next';
import { Button } from '@peacecover/component';

export default function ImageSearchFailure({
  imageData,
  selectedMember,
  onBackClick,
  onAnotherSearchClick
}: {
  imageData: string;
  selectedMember: ImageSearchResultType['selectedMember'];
  onBackClick: () => void;
  onAnotherSearchClick: () => void;
}) {
  return (
    <CenterScreenWrapper
      onBackClick={onBackClick}
      topNavigationTitle={t('imageSearch.searchResult.topNavigationTitle') as string}
    >
      <div className="flex flex-col items-center gap-[16px] w-full">
        <ImageScanOverlay
          imageData={imageData}
          selectedMember={selectedMember}
          isLoading={true}
          isPhotoCardRatio={false}
          size="sm"
        />
        <div className="flex flex-col items-center gap-[14px]">
          <p className="text-pure-black text-[26px] font-bold dark:text-main-dark-1 text-center leading-tight">
            <span className="block">{t('imageSearch.searchResult.noResultTitle')}</span>
            <span className="block">{t('imageSearch.searchResult.noResultTitle2')}</span>
          </p>
          <p className="text-main-light-4 text-[15px] font-medium dark:text-main-dark-4 leading-none">
            {t('imageSearch.searchResult.reportDescription')}
          </p>
        </div>
        <div className=" mt-[174px] w-full px-[24px]">
          <Button
            size="large"
            variant="primary"
            className="w-full text-[17px] font-semibold"
            onClick={onAnotherSearchClick}
          >
            {t('imageSearch.searchResult.anotherSearch')}
          </Button>
        </div>
      </div>
      <div className="h-[10vh]" />
    </CenterScreenWrapper>
  );
}
